'use client';

import {
  TTypographyColor,
  Typography,
} from '@/components/atoms/Typography/Typography';
import {
  IProjectTable,
  ProjectTable,
} from '@/components/molecules/ProjectTable/ProjectTable';
import { ICommonProps, TComponentWidth } from '@/types/global';
import { ComponentContainer } from '@/components/atoms/ComponentContainer/ComponentContainer';
import * as Styled from './InfoColumns.styled';

export type TColumn = {
  type: 'text' | 'table';
  content: string | IProjectTable;
};

interface IInfoColumns extends ICommonProps {
  columns: TColumn[];
  width: TComponentWidth;
  colorText?: TTypographyColor;
}

export function InfoColumns({
  columns,
  width = 'content',
  isProject = true,
  colorText = 'tertiary',
  marginBottom = 'inner',
  marginBottomOnMobile = 'inner',
}: IInfoColumns) {
  return (
    <ComponentContainer
      width={width}
      marginBottom={marginBottom}
      marginBottomOnMobile={marginBottomOnMobile}
      isProject={isProject}
    >
      <Styled.Columns className='info-columns'>
        {columns.map((column, i) =>
          ((column.type === 'text' && column.content) || (column.type === 'table' && column.content)) ? (
            <Styled.Column
              key={`info-column-${i}`}
              span={column.type === 'table' ? 2 : 1}
              componentWidth={width}
              pageType={isProject ? 'project' : 'page'}
              className='info-column'
            >
              {column.type === 'text' && (
                <Typography
                  text={column.content as string}
                  className={'info-text'}
                  addIndentAfterLineBreak={true}
                  color={colorText}
                />
              )}
              {column.type === 'table' && (
                <ProjectTable rows={(column.content as IProjectTable).rows} />
              )}
            </Styled.Column>
          ) : null
        )}
      </Styled.Columns>
    </ComponentContainer>
  );
}
